import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Provider } from './provider';

@inheritSerialization(AbstractModel)
export class ProviderRequest extends AbstractModel {
  @autoserializeAs(Provider)
  provider: Provider;

  @autoserialize
  transitProgramIds: Array<number>;

  @autoserialize
  serviceLevelIds: Array<number>;
}
